import React, { FC, ReactNode } from "react";
import { joinClassNames as c } from "Shared/util/styles";
import styles from "./colored-text.css";

type ColoredTextProps = {
    color: "default" | "red";
    content: string | ReactNode;
};

export const ColoredText: FC<ColoredTextProps> = ({ color, content }) => (
    <div className={c(color === "red" && styles.red)}>{content}</div>
);
